import {Component, EventEmitter, Input, Output} from '@angular/core';
import {
  ApplicationFormSettings,
  Competitor,
  CompetitorFilter,
  EventItem,
  Lookups,
  PagedFilter,
  RaceSettings
} from "@model";

@Component({
  selector: 'app-event-management-participants-list',
  templateUrl: './event-management-participants-list.component.html',
  styleUrl: './event-management-participants-list.component.scss'
})
export class EventManagementParticipantsListComponent {

  @Input() filter: PagedFilter<CompetitorFilter> | undefined;
  @Input() searchForm: any;
  @Input() event: EventItem | undefined;
  @Input({required: true}) languages: Lookups[] = [];
  @Input({required: true}) disableRegisterToRace: boolean = false;
  @Input() raceSettingsList: RaceSettings[] = [];
  @Input() applicationFormSettingsList: ApplicationFormSettings[] = []
  @Input() competitors: Competitor[] = [];
  @Output() registerToRace: EventEmitter<void> = new EventEmitter<void>();
  @Output() getFileFromServer: EventEmitter<{ type: string, filter: PagedFilter<CompetitorFilter> | undefined }>
    = new EventEmitter<{ type: string, filter: PagedFilter<CompetitorFilter> | undefined }>();

  onFilterChange(filter: PagedFilter<CompetitorFilter> | undefined): void {
    this.filter = filter;
  }

  onRegisterToRace() {
    this.registerToRace.next();
  }

  onGetFileFromServer(type: string) {
    this.getFileFromServer.next({type: type, filter: this.filter});
  }

}
